<template>
<div class="full-wrapper pannel">
  <el-scrollbar :ref="scrollbarRef">
    <div class="full">
      <w-operation-state-info :params="params" :event-info="eventInfoData"></w-operation-state-info>
      <el-row>
        <div class="row">
          <el-col :md="24" :lg="12">
            <w-perf-widget :show-change-btn="false">
              <span slot="perfHeader">구성 정보</span>
              <div slot="perfBody">
                <el-col :md="24" :lg="12">
                  <table class="list-none-border">
                    <tr>
                      <th>서비스명</th>
                      <td>{{ configInfoData.objName }}</td>
                    </tr>
                    <tr v-for="item in configLeftData" :key="item.elementType">
                      <th>{{ item.elementTypeName }}</th>
                      <td>
                        <div>
                          {{ getValuewithCountUnit(item.elementType, item.elementTypeCount) }}
                        </div>
                        <div v-if="item.rscKeyCount">
                          <li v-for="rscKey in item.rscKeyCount" :key="item.rsctypeId">
                            {{ getRscKeyName(rscKey.rsctypeId)}}: {{getValuewithCountUnit(rscKey.rsctypeId, rscKey.rscKeyCount)}}
                          </li>
                        </div>
                      </td>
                    </tr>
                  </table>
                </el-col>
                <el-col :md="24" :lg="12">
                  <table class="list-none-border">
                    <tr v-for="item in configRightData" :key="item.elementType">
                      <th>{{ item.elementTypeName }}</th>
                      <td>
                        <div>
                          {{ getValuewithCountUnit(item.elementType, item.elementTypeCount) }}
                        </div>
                        <div v-if="item.rscKeyCount">
                          <li v-for="rscKey in item.rscKeyCount" :key="item.rsctypeId">
                            {{ getRscKeyName(rscKey.rsctypeId)}}: {{getValuewithCountUnit(rscKey.rsctypeId, rscKey.rscKeyCount)}}
                          </li>
                        </div>
                      </td>
                    </tr>
                  </table>
                </el-col>
              </div>
              <div slot="perfFooter">
                <span>최근 변경시각: {{ configInfoData.checkDatetimeLabel }}</span>
              </div>
            </w-perf-widget>
          </el-col>
          <el-col :md="24" :lg="12">
            <w-event-info-widget :event-info-data="eventInfoData"></w-event-info-widget>
          </el-col>
        </div>
      </el-row>
      <el-row>
        <w-performance-list :performance-data="performanceList"></w-performance-list>
      </el-row>
    </div>
  </el-scrollbar>
  <w-scroll-top-button :visible="enableScollTop" @move-scroll-top="moveScrollTop"/>
</div>
</template>

<script>
import clone from 'lodash/clone';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import forEach from 'lodash/forEach';
import moment from 'moment';
import { mapGetters } from 'vuex';
import ScrollbarMixin from '@/mixins/scrollbar';
import serviceApi from '@/api/performance/service/service';
import summaryApi from '@/api/performance/summary/summary-info';
import { getIntervalDatetimeParams } from '@/utils/date';
import WPerfWidget from '../components/PerfWidget';
import WOperationStateInfo from '../components/OperationStateInfo';
import WEventInfoWidget from '../components/EventInfoWidget';
import WPerformanceList from '../../../components/PerformanceList';

export default {
  name: 'WPerformanceServiceSummary',
  mixins: [ScrollbarMixin],
  components: {
    WPerfWidget,
    WOperationStateInfo,
    WEventInfoWidget,
    WPerformanceList,
  },
  props: {
    active: {
      type: Boolean,
      defulat: () => false,
    },
  },
  computed: mapGetters(['selectedNode']),
  data() {
    return {
      params: {
        managetypeId: 'SVC',
      },
      configInfoData: {},
      configLeftData: [],
      configRightData: [],
      eventInfoData: {},
      performanceList: [],
    };
  },
  watch: {
    selectedNode: {
      handler(node) {
        if (isEmpty(node)) {
          return;
        }
        this.loadData();
      },
      immediate: true,
    },
    active: {
      handler() {
        this.loadData();
      },
    },
  },
  mounted() {
    this.setScrollData();
  },
  methods: {
    getIntervalDatetimeParams,
    loadData() {
      if (this.active) {
        const startDatetime = this.getIntervalDatetimeParams(new Date(), 'hour', 12);
        Object.assign(this.params, {
          objId: this.selectedNode.obj.objId,
          startDatetime,
        });
        this.loadConfInfoView();
        this.loadEventInfo();
        this.loadPerformanceList();
      }
    },
    /**
     * 구성 정보 load
     * @author jeee12
     */
    loadConfInfoView() {
      serviceApi
        .getServiceConfigurationInfo({
          objId: this.selectedNode.obj.objId,
        })
        .then((response) => {
          if (response.data.success) {
            const configInfo = response.data.data;
            configInfo.checkDatetimeLabel = !isNil(configInfo.checkDatetime) ? moment(configInfo.checkDatetime).format('YYYY년 MM월 DD일 HH:mm:ss') : '-';
            this.configInfoData = configInfo;
            if (isEmpty(configInfo.configCount)) {
              this.configLeftData = [];
              this.configRightData = [];
            } else {
              const configCount = configInfo.configCount;
              let total = 0;
              forEach(configCount, (item) => {
                total += 1;
                item.length = 1;
                if (!isEmpty(item.rscKeyCount)) {
                  total += item.rscKeyCount.length;
                  item.length += item.rscKeyCount.length;
                }
              });

              let length = 0;
              const half = total / 2;
              const configLeftData = [];
              const configRightData = [];
              forEach(configCount, (item) => {
                // if (total < 5) {
                //   configLeftData.push(item);
                // } else
                length += item.length;
                if (length < half) {
                  configLeftData.push(item);
                } else {
                  configRightData.push(item);
                }
              });

              this.configLeftData = configLeftData;
              this.configRightData = configRightData;
            }
          }
        });
    },
    /**
     * 이벤트 정보 조회
     * @author jeee12
     */
    loadEventInfo() {
      const params = clone(this.params);
      params.endDatetime = new Date().getTime();

      summaryApi.getSummaryEventInfo(params).then((response) => {
        if (response.data.success) {
          this.eventInfoData = response.data.data;
        }
      });
    },
    /**
     * 서비스 성능 정보 조회
     * @author jeee12
     */
    loadPerformanceList() {
      serviceApi
        .getServicePerformance({
          serviceId: this.selectedNode.obj.objId,
          startDatetime: this.params.startDatetime,
          endDatetime: new Date().getTime(),
        })
        .then((response) => {
          if (response.data.success) {
            this.performanceList = response.data.data;
          }
        });
    },
    getValuewithCountUnit(key, value) { // 수정 시  EventInfo.vue도 함께 영향도 파악 필요
      if (key === 'NETINTERFACE') {
        return `${value} 포트`;
      } else if (['SERVER', 'NETDEVICE', 'DBMS'].indexOf(key) >= 0) {
        return `${value} 대`;
      }
      return `${value} 개`;
    },
    getRscKeyName(key) {
      let name;
      if (key === 'APPLOG') {
        name = '어플리케이션 로그';
      } else if (key === 'MAJORPROC') {
        name = '중요 프로세스';
      } else if (key === 'SERVICE_PORT') {
        name = '서비스 포트';
      } else if (key === 'SYSLOG') {
        name = 'Syslog';
      } else {
        name = '';
      }
      return name;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/summary/service/index.vue